import { useCallback, useMemo, useState } from "react";

import type { AreaGraphProps } from "@similarweb/pro-logic-components";

type SelectionState = Record<string, boolean>;

export const useCompetitorsSelectionManager = (chartData: AreaGraphProps<unknown>["data"]) => {
    const [selection, setSelection] = useState<SelectionState>({});

    const updateSelection = useCallback((seriesId: string, isSelected: boolean) => {
        setSelection((prevState) => ({
            ...prevState,
            [seriesId]: isSelected,
        }));
    }, []);

    const updateBulkSelection = useCallback((newSelection: SelectionState) => {
        setSelection(newSelection);
    }, []);

    const resultData = useMemo<AreaGraphProps<unknown>["data"]>(() => {
        if (!chartData || chartData.length === 0) {
            return chartData;
        }
        return chartData.map((item) => ({
            ...item,
            visible: item.id in selection ? selection[item.id] : item.visible,
        }));
    }, [chartData, selection]);

    const selectedSeriesIds = useMemo(() => {
        return new Set(Object.keys(selection).filter((id) => selection[id]));
    }, [selection]);

    return {
        chartData: resultData,
        selectedSeriesIds,
        updateSelection,
        updateBulkSelection,
    };
};
